
<div class="row">
  <div class="col-sm-12">
    <h3 class="sub-title alert alert-info">Role Groups</h3></div>
  <div class="col-sm-12 text-end alert">
      <a [routerLink]="['/admin/roleGroup/new',0]" class ="btn btn-primary"> <i class="fa fa-plus"></i> Add New role</a>
  </div>
</div>
<div class="table-responsive" *ngIf="roleGroups">

<table  datatable [dtOptions]="dtOptions" class="table table-striped display compact">
  <thead>
  <tr>
    <th>Id</th>
    <th>Name</th>
    <th>Date Created</th>
<th>Actions</th>
  </tr>
  </thead>

  <tbody>

  <tr *ngFor="let role of roleGroups;">
    <td>{{role['id']}}</td>
     <td>
      <a [routerLink]="['/admin/roles/user/index',role['id']]">
      {{role['name']}}
      </a>
    </td>
    <td>{{role['dateCreated']}}</td>
    <th>
      <a [routerLink]="['/admin/roleGroup/new',role['id']]" class="btn btn-primary">Edit</a>
      <a (click)="deleteRoleGroup(role['id'])" class="btn btn-danger me-2">Delete</a>

      <a [routerLink]="['/admin/roles/user/index',role['id']]" class="btn btn-info">Users</a>
      <a [routerLink]="['/admin/permission/index',role['id']]" class="btn btn-info me-2">Roles</a>

      <a [routerLink]="['/admin/user/addToGroup',role['id']]" class="btn btn-info">Add user</a>
      <a [routerLink]="['/admin/permission/addToGroup',role['id']]" class="btn btn-info">Add Role</a>
      </th>

  </tr>

  </tbody>

</table>

</div>

<app-spinner *ngIf="roleGroups && loading"></app-spinner>
<div *ngIf="roleGroups && !loading" class="text-center">No Records Found </div>

<hr/>
<div class="text-center" >
  <a [routerLink]="['/admin/roleGroup/new/0']">Add New  role</a>
</div>



